import { combineReducers } from "redux";

import orgReducer from "../organisation/reducer";
import certificationReducer from "../certification/reducer";
import setReferance from "../ref/reducer";

export default combineReducers({
  organisationData: orgReducer,
  certification: certificationReducer,
  ref: setReferance,
});
